import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { ArraySlicePipe } from '../../../../shared/pipes/array-slice.pipe';
import { ChipComponent } from '../../../../shared/components/chip/chip.component';
import { PagedTableComponent } from '../../../../shared/components/paged-table/paged-table.component';
import { NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { BasePagedTableComponent } from '../../../../core/layout/components/abstracts/base-paged-table.component';
import { CardsService } from '../../core/services/CardsService';
import { Observable } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { IPagedResults } from '../../../../core/interfaces/IPagedResults';
import { IAvailableProductForCard } from '../../core/interfaces/IAvailableProductForCard';
import { CardsStore } from '../../core/stores/CardsStore';

@Component({
  selector: 'app-products-table',
  standalone: true,
  imports: [
    ArraySlicePipe,
    ChipComponent,
    PagedTableComponent,
    NgTemplateOutlet,
    TranslatePipe
  ],
  templateUrl: './products-table.component.html',
  styleUrl: './products-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductsTableComponentextends extends BasePagedTableComponent<IAvailableProductForCard> {

  @Output() selectedProductIdsChanged = new EventEmitter<Map<number, number>>();

  public readonly selectedProductIds = new Map<number, number>();
  public readonly productGroups = inject(CardsStore).productGroups;
  public readonly selectedProductGroupIds = new Map<number, number>(
    this.productGroups().map(g => [g.id, g.id])
  );

  private readonly _cardsService = inject(CardsService);

  protected override get data$(): Observable<IResponse<IPagedResults<IAvailableProductForCard>>> {
    return this._cardsService.getAvailableProductsForCard(
      this.pagination,
      Array.from(this.selectedProductGroupIds.keys())
    );
  }
}
